/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Student_AmountInputs */

const en_student_amount = /** @type {(inputs: Student_AmountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Amount`)
};

const he_student_amount = /** @type {(inputs: Student_AmountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`סכום`)
};

/**
* | output |
* | --- |
* | "Amount" |
*
* @param {Student_AmountInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const student_amount = /** @type {((inputs?: Student_AmountInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Student_AmountInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_student_amount(inputs)
	return he_student_amount(inputs)
});